import {Action, Selector, State, StateContext, Store} from "@ngxs/store";
import {WalletsStateInterface} from "../models/wallets-state.interface";
import {CarteraStateInterface} from "../models/cartera-state.interface";
import {Injectable} from "@angular/core";
import {RequestService} from "../services/request.service";
import {AppHelper} from "../helpers/app.helper";
import {WalletsAction} from "../actions/wallets-action";
import FetchWallets = WalletsAction.FetchWallets;
import UpsertWallet = WalletsAction.UpsertWallet;
import RemoveWallet = WalletsAction.RemoveWallet;
import CloneWallet = WalletsAction.CloneWallet;

import { CarteraService } from '../services/cartera.service';

@State<WalletsStateInterface>({
  name: 'walletsData',
  defaults: {
    wallets: []
  }
})
@Injectable()
export class WalletState {

  constructor(private store: Store, private requestService: RequestService, private carteraService: CarteraService) {
  }

  @Selector()
  static wallets(state: WalletsStateInterface) {

    return JSON.parse(JSON.stringify(state.wallets));
  }


  @Action(FetchWallets)
  async fetchWallets({getState, setState}: StateContext<WalletsStateInterface>, action: FetchWallets){

    let data = [];
    try {

      let query = `exists[deletedAt]=0`;

      if (action.id) {

        query += `&id=${action.id}`;
      }

      data = await this.requestService.get('cartera_index',
        { hideLoading: action.hideLoading, params: { }, query });

      data.forEach(c => {

        c.precioTotal = AppHelper.FormatNumber(c.precioTotal || 0, this.carteraService.locale,
            2, 'currency', c.moneda);
        AppHelper.FormatFromColumn( c, this.store
          .selectSnapshot<CarteraStateInterface>( state => state.carteraData).carteraColumnas, this.carteraService.locale );
      });

    } catch (e) {

      AppHelper.DevPrint(e);
    }

    setState({ ...getState(), ... { wallets: data } });
  }

  @Action(UpsertWallet)
  async upsertWallets({getState, setState}: StateContext<WalletsStateInterface>, action: UpsertWallet){

    const state = getState();
    try {

      const carteras = JSON.parse(JSON.stringify(state.wallets));

      const index = carteras.findIndex(c => c.id === action.cartera?.id);

      if (!action.cartera?.id || index < 0) {

        carteras.push(await this.requestService.post('cartera_index', {
          params: {
            nombre: action.cartera.nombre,
            moneda: action.cartera.moneda || 'EUR'
          }
        }));
      } else {

        carteras[index] = await this.requestService.put('cartera_details',
          { hideLoading: true,
            params: { ... carteras[index], ...action.cartera } });
      }

      setState({ ...getState(), ... { wallets: carteras } });
    } catch (e) {

      AppHelper.DevPrint(e);
    }
  }

  @Action(RemoveWallet)
  async removeWallets({getState, setState}: StateContext<WalletsStateInterface>, action: RemoveWallet){

    const state = getState();
    try {

      const carteras = JSON.parse(JSON.stringify(state.wallets));

      const index = carteras.findIndex(c => c.id === action.id);

      if (index >= 0) {

        await this.requestService.delete('cartera_details', { hideLoading: false, params: { id: action.id } });
        carteras.splice(index, 1);
        setState({ ...getState(), ... { wallets: carteras } });
      }

    } catch (e) {

      AppHelper.DevPrint(e);
    }
  }

  @Action(CloneWallet)
  async cloneWallets({getState, setState}: StateContext<WalletsStateInterface>, action: CloneWallet){

    const state = getState();
    try {

      const carteras = JSON.parse(JSON.stringify(state.wallets));

      carteras.push(await this.requestService.post('cartera_clone',
        { params: { id: action.id } }));

        setState({ ...getState(), ... { wallets: carteras } });
    } catch (e) {

      AppHelper.DevPrint(e);
    }
  }

  
}
